export enum LogoVariant {
  Default = 'url(#logo-gradient-coloured)',
  White = '#ffffff',
}
